export const REALTIME_REDIS_CHANNEL = "cf:realtime:v1";

export type CfRealtimeEvent = {
  id: string;
  type: string;
  pageId?: string;
  feedId?: string;
  sessionId?: string;
  entityId?: string;
  revision: string;
  occurredAt: string;
};

export function isCfRealtimeEvent(value: unknown): value is CfRealtimeEvent {
  if (!value || typeof value !== "object") return false;
  const event = value as Record<string, unknown>;
  return (
    typeof event.id === "string" &&
    typeof event.type === "string" &&
    typeof event.revision === "string" &&
    typeof event.occurredAt === "string"
  );
}
